define.alias("ember-text-measurer/services/text-measurer", "calendar/services/text-measurer");